import { TimelineFeedItem } from '@/components/timeline/TimelineFeedItem';
import type { ActivityEvent } from '@/lib/activityFeed';
import { getActivityEventPresentation } from '@/lib/activityFeed';
import { Clock, MessageSquare, Sparkles } from 'lucide-react';

type ActivityFeedItemProps = {
  event: ActivityEvent;
};

export function ActivityFeedItem({ event }: ActivityFeedItemProps) {
  const { tone, timeLabel, label, summary, privacyLabel, isNewChat, messageCount } =
    getActivityEventPresentation(event);
  const messageBadgeLabel =
    typeof messageCount === 'number'
      ? `Invio ${messageCount} ${messageCount === 1 ? 'messaggio' : 'messaggi'}`
      : null;
  const badges = [
    ...(isNewChat ? [ { icon: Sparkles, label: 'Nuova chat' } ] : []),
    ...(messageBadgeLabel ? [ { icon: MessageSquare, label: messageBadgeLabel } ] : []),
  ];

  return (
    <TimelineFeedItem
      tone={tone}
      timeLabel={timeLabel}
      timeBadge={{ icon: Clock, label: timeLabel }}
      label={label}
      summary={summary}
      href={event.url}
      sentiment={event.sentiment}
      privacyLabel={privacyLabel}
      metaBadges={badges}
    />
  );
}
